import React from 'react';
import { useInView } from 'react-intersection-observer';
import Donate from "./img/Donate.avif";

const FertilitySection = () => {
  const { ref: heroRef, inView: heroInView } = useInView({ triggerOnce: true, threshold: 0.1 });
  const { ref: gridRef, inView: gridInView } = useInView({ triggerOnce: true, threshold: 0.1 });
  const { ref: ctaRef, inView: ctaInView } = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <div id="ultra-premium-effects">
      <style>
        {`
          #ultra-premium-effects {
            /* Logo Theme Colors */
            --brand-pink: #ec1c74;
            --brand-blue: #00a8e8;
            --bg-color: #fbfcfd;
            --glass-bg: rgba(255, 255, 255, 0.7);
            --glass-border: rgba(255, 255, 255, 0.9);
            --text-dark: #1d1d1f;
            --text-muted: #6e6e73;
            --accent-gradient: linear-gradient(135deg, var(--brand-blue), var(--brand-pink));
            
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
            background: radial-gradient(circle at 10% 20%, rgba(0, 168, 232, 0.04) 0%, transparent 40%), 
                        radial-gradient(circle at 90% 80%, rgba(236, 28, 116, 0.04) 0%, transparent 40%);
            background-color: var(--bg-color);
            padding: 5rem 2rem;
            box-sizing: border-box;
            overflow: hidden;
          }

          #ultra-premium-effects * {
            box-sizing: border-box;
          }

          #ultra-premium-effects .premium-container {
            max-width: 1200px;
            margin: 0 auto;
          }

          /* Animations */
          .fade-up {
            opacity: 0;
            transform: translateY(30px);
            transition: opacity 0.8s ease-out, transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
          }
          .fade-up.animate {
            opacity: 1;
            transform: translateY(0);
          }

          /* Hero Section */
          #ultra-premium-effects .hero-section {
            display: flex;
            align-items: center;
            gap: 4rem;
            margin-bottom: 5rem;
            background: var(--glass-bg);
            backdrop-filter: blur(24px);
            -webkit-backdrop-filter: blur(24px);
            border: 1px solid var(--glass-border);
            border-radius: 40px;
            padding: 3rem;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.03);
          }

          #ultra-premium-effects .hero-image-wrapper {
            flex: 1;
            border-radius: 24px;
            overflow: hidden;
            box-shadow: 0 10px 30px rgba(0,0,0,0.08);
          }

          #ultra-premium-effects .hero-image-wrapper img {
            width: 100%;
            height: auto;
            display: block;
            object-fit: cover;
            transform: scale(1.01); /* Prevents white edges */
          }

          #ultra-premium-effects .hero-content {
            flex: 1.2;
          }

          #ultra-premium-effects .hero-title {
            font-size: 2.8rem;
            font-weight: 800;
            color: var(--text-dark);
            margin: 0 0 1.5rem 0;
            letter-spacing: -0.03em;
            line-height: 1.1;
          }

          #ultra-premium-effects .hero-title span {
            background: var(--accent-gradient);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }

          #ultra-premium-effects .hero-desc {
            font-size: 1.15rem;
            color: var(--text-muted);
            line-height: 1.7;
            margin: 0;
          }

          /* Bento Grid for Effects */
          #ultra-premium-effects .effects-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
            gap: 1.5rem;
            margin-bottom: 4rem;
          }

          #ultra-premium-effects .effect-card {
            background: rgba(255, 255, 255, 0.6);
            backdrop-filter: blur(16px);
            -webkit-backdrop-filter: blur(16px);
            border: 1px solid var(--glass-border);
            border-radius: 28px;
            padding: 2.5rem 2rem;
            transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.02);
            position: relative;
          }

          #ultra-premium-effects .effect-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 15px 35px rgba(0, 168, 232, 0.06);
            background: rgba(255, 255, 255, 0.9);
            border-color: rgba(236, 28, 116, 0.15);
          }

          /* Small gradient dot indicator */
          #ultra-premium-effects .effect-card::before {
            content: '';
            position: absolute;
            top: 2.5rem;
            left: 2rem;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background: var(--accent-gradient);
          }

          #ultra-premium-effects .effect-card h4 {
            font-size: 1.3rem;
            font-weight: 700;
            color: var(--text-dark);
            margin: 0 0 1rem 0;
            padding-left: 1.5rem; /* space for the dot */
          }

          #ultra-premium-effects .effect-card p {
            font-size: 1rem;
            color: var(--text-muted);
            line-height: 1.6;
            margin: 0;
          }

          /* CTA Box */
          #ultra-premium-effects .cta-box {
            background: linear-gradient(135deg, #1d1d1f, #2d2d30);
            border-radius: 32px;
            padding: 4rem 3rem;
            text-align: center;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
            position: relative;
            overflow: hidden;
          }

          /* Glowing brand colors behind CTA */
          #ultra-premium-effects .cta-box::before {
            content: '';
            position: absolute;
            top: -50%; left: -50%; width: 200%; height: 200%;
            background: radial-gradient(circle at 50% 100%, rgba(236, 28, 116, 0.15), transparent 60%);
            pointer-events: none;
          }

          #ultra-premium-effects .cta-box h3 {
            color: #ffffff;
            font-size: 2.2rem;
            font-weight: 700;
            margin: 0 0 1rem 0;
          }

          #ultra-premium-effects .cta-box p {
            color: rgba(255, 255, 255, 0.8);
            font-size: 1.15rem;
            line-height: 1.7;
            max-width: 700px;
            margin: 0 auto;
          }

          /* Responsive Tweaks */
          @media (max-width: 992px) {
            #ultra-premium-effects .hero-section {
              flex-direction: column;
              text-align: center;
              padding: 2.5rem;
            }
            #ultra-premium-effects .hero-image-wrapper {
              width: 100%;
              max-width: 500px;
            }
          }

          @media (max-width: 768px) {
            #ultra-premium-effects { padding: 3rem 1rem; }
            #ultra-premium-effects .hero-title { font-size: 2.2rem; }
            #ultra-premium-effects .cta-box { padding: 3rem 2rem; }
            #ultra-premium-effects .effects-grid { grid-template-columns: 1fr; }
          }
        `}
      </style>

      <div className="premium-container">
        
        {/* Hero Section */}
        <div ref={heroRef} className={`hero-section fade-up ${heroInView ? 'animate' : ''}`}>
          <div className="hero-image-wrapper">
            <img src={Donate} alt="Wellness Center Healing" loading="lazy" decoding="async" />
          </div>
          <div className="hero-content">
            <h2 className="hero-title">Understanding the <br /><span>Effects of Alcohol</span></h2>
            <p className="hero-desc">
              Excessive alcohol consumption can have several harmful effects on your health, relationships, and overall well-being. At our Wellness Center, we specialize in helping individuals overcome these exact challenges to restore a deeply balanced and healthy life.
            </p>
          </div>
        </div>

        {/* Bento Grid for Points */}
        <div ref={gridRef} className={`effects-grid fade-up ${gridInView ? 'animate' : ''}`}>
          
          <div className="effect-card">
            <h4>Physical Health Issues</h4>
            <p>Alcohol puts excessive strain on the liver, increases the risk of high blood pressure and heart disease, weakens the immune system, and can lead to long-term brain function impairment.</p>
          </div>

          <div className="effect-card">
            <h4>Substance Dependency</h4>
            <p>Alcohol can lead to strong physical and mental dependency. Our Wellness Center provides the necessary holistic care to help individuals break free from this cycle safely.</p>
          </div>

          <div className="effect-card">
            <h4>Mental Health Impact</h4>
            <p>Often used to cope with stress, alcohol actually worsens depression and anxiety. It disrupts brain chemicals, impairs judgment, and can lead to risky behavior or increased aggression.</p>
          </div>

          <div className="effect-card">
            <h4>Impact on Relationships</h4>
            <p>Excessive drinking strains bonds with family and friends through misunderstandings and behavioral changes. Rebuilding these connections is a core part of our healing journey.</p>
          </div>

          <div className="effect-card">
            <h4>Social Consequences</h4>
            <p>Beyond the individual, alcohol impacts society through severe risks like drunk driving, leading to potential legal and long-term financial burdens.</p>
          </div>

          <div className="effect-card">
            <h4>Increased Risk of Cancer</h4>
            <p>Drinking has been clinically linked to a higher risk of several types of cancer, including mouth, throat, liver, breast, and colon. The risk increases with frequency.</p>
          </div>

          <div className="effect-card">
            <h4>Sleep Disturbances</h4>
            <p>While it may make you feel drowsy initially, alcohol disrupts the natural sleep cycle, preventing deep, restorative rest and leading to severe fatigue the next day.</p>
          </div>

          <div className="effect-card">
            <h4>Weight Gain & Digestion</h4>
            <p>High in calories and low in nutrients, alcohol contributes to weight gain. It also irritates the digestive system, causing gastritis, acid reflux, and essential nutrient deficiencies.</p>
          </div>

        </div>

        {/* Final CTA Box */}
        <div ref={ctaRef} className={`cta-box fade-up ${ctaInView ? 'animate' : ''}`}>
          <h3>Begin Your Healing Journey</h3>
          <p>
            If you or a loved one are experiencing any of these negative effects, it is never too late to seek help. Our Wellness Center is dedicated to guiding you through a safe, supportive, and holistic path to restore your physical and mental well-being.
          </p>
        </div>

      </div>
    </div>
  );
};

export default FertilitySection;